module.exports = __webpack_public_path__ + "media/mypage/images/service/icon_001-ff0e2bc3c26fe8140fc9c6440c5a9901.png";